import React, { Component } from 'react';
import { ProjectDetails } from "../parts/details.js";
import { ProjectTags } from "../parts/tags.js";
import { ProjectResources } from "../parts/resources.js";
import { needFlags } from "../util/flagcalc";
import Styles from "../Styles.js";
import { GlobalContext } from '../global-context.js';
import AddMember from '../parts/addmember';
import { PROJECTDENIED, PROJECTCLOSED, PROJECTREQUESTED, PROJECTCLOSEREQUESTED } from '../util/constants';

class UpdateProjectContainer extends Component {
    static contextType = GlobalContext;

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            project: null
        };
    }

    async update() {
        const project_id = this.props.match.params.id;
        const { devmode, setGlobalError, updateProject } = this.context;
        let res = await fetch(`/api/project/${project_id}`)
        if (res.ok) {
            let proj = await res.json();
            devmode && console.log("Project:", proj);
            this.setState({
                id: project_id,
                project: proj
            });
            updateProject(proj);
            return
        }
        const errdata = await res.json();
        const message = `error ${res.status} fetching project ${project_id}: ${errdata.message}`;
        console.log(message);
        setGlobalError(message);
    }

    addMember = async (value) => {
        let member_error = undefined;
        let updated = undefined;
        const { project } = this.state;
        const endpoint = `/api/project/${project.id}/addmember/${value}`;
        let res = await fetch(endpoint, { method: 'POST' }).catch((error) => {
          console.log("ERROR in member lookup:", error);
        });
        if (!res || res.ok === false) {
            let errdata = await res.json()
            member_error = errdata.message;
        } else {
            updated = await res.json();
        }
        if (! member_error) {
            this.setState({ project: updated})
        }
        return member_error;
    }

    verifyMember = async (eppn) => {
        let member_error = undefined;
        let updated = undefined;
        const { project } = this.state;
        const endpoint = `/api/project/${project.id}/verifymember/${eppn}`;
        let res = await fetch(endpoint, { method: 'PUT' }).catch((error) => {
          console.log("ERROR in member lookup:", error);
        });
        if (!res || res.ok === false) {
            let errdata = await res.json()
            member_error = errdata.message;
        } else {
            updated = await res.json();
        }
        if (! member_error) {
            this.setState({ project: updated})
        }
        return member_error;
    }

    removeMember = async (eppn) => {
        let member_error = undefined;
        let updated = undefined;
        const { project } = this.state;
        const endpoint = `/api/project/${project.id}/removemember/${eppn}`;
        let res = await fetch(endpoint, { method: 'PUT' }).catch((error) => {
          console.log("ERROR in member lookup:", error);
        });
        if (!res || res.ok === false) {
            let errdata = await res.json()
            member_error = errdata.message;
        } else {
            updated = await res.json();
        }
        if (! member_error) {
            this.setState({ project: updated})
        }
        return member_error;
    }

    promoteMember = async (eppn) => {
      const { navigate } = this.props;
      const { project } = this.state;
      navigate(`promote?member=${eppn}&project=${project.id}`);
    }

    shouldComponentUpdate(props, state) {
        if (props.match.params.id === state.id) {
            return true
        }
        this.update();
        return false
    }

    componentDidMount() {
        this.update();
    }

    render() {
        if (!(this.state.id)) {
            return null
        }
        const { project } = this.state;
        const pstate = project.state ? project.state : 0
        const isactive = pstate !== PROJECTDENIED && pstate !== PROJECTCLOSED && pstate !== PROJECTCLOSEREQUESTED
        const isrequested = pstate === PROJECTREQUESTED
        const isready = isactive && !isrequested
        const { config, person } = this.context;
        const { navigate } = this.props;
        let adminMenu = null;
        const isAdmin = person.roles.length > 0;
        if (isAdmin) {
            const roles = person.roles
            adminMenu = <div>
                <h2>Administrator Functions</h2>
                <ul>
                    {roles.includes("approver") && isrequested &&
                    <li onClick={() => navigate(`approve?project=${project.id}`)} style={{cursor: "pointer"}}><b>Approve / Reject Project</b></li>}
                </ul>
                <ul>
                    {roles.includes("verifier") &&
                    <li onClick={() => navigate(`verify?project=${project.id}`)} style={{cursor: "pointer"}}><b>Verify Member Flags</b></li>}
                </ul>
                <ul>
                    {roles.includes("provisioner") && isready &&
                    <li onClick={() => navigate(`provision?project=${project.id}`)} style={{cursor: "pointer"}}><b>Provision Resources</b></li>}
                </ul>
                <ul>
                    {roles.includes("provisioner") && isready &&
                    <li onClick={() => navigate(`userprovision?project=${project.id}`)} style={{cursor: "pointer"}}><b>Provision Users</b></li>}
                </ul>
            </div>
        }

        let sigsRequired = null;
        const flagsNeeded = needFlags(project, person, config).sflagsNeeded;
        if (flagsNeeded.length > 0) {
            sigsRequired = <div>
                <h2 style={{color: "#800"}}>ACTION REQUIRED - Document Signatures Needed:</h2>
                {
                    flagsNeeded.map(needFlag => {
                        return (
                            <div key={needFlag}
                              onClick={() => navigate(`sign?project=${project.id}&document=${needFlag}`)}
                              className="project-sensitivity"
                              style={{cursor: "pointer", padding: "10px", marginBottom: "25px", width: "250px"}}>
                                Sign &#8594; {needFlag}
                            </div>
                        );
                    })
                }
            </div>
        }

        const is_pi = person.id === project.principal_investigator;

        return (
            <div style={{padding: "20px"}}>
              <Styles>
                {isactive && sigsRequired}
                {pstate === PROJECTCLOSED && <h2>Project Closed</h2>}
                {pstate === PROJECTDENIED && <h2 style={{color: "#800"}}>Project Denied: {project.comment}</h2>}
                <h1>{project.title}</h1>
                <div>{project.description}</div>
                <h2>Regulatory Classification(s)</h2>
                <table className="project-tags">
                    <tbody>
                    {
                        project.flags && project.flags.map((flag) =>
                        <tr key={flag.name}>
                            <td className="project-sensitivity">{flag.name}</td>
                        </tr>
                    )}
                    </tbody>
                </table>
                {isactive && adminMenu}
                <ProjectDetails
                  project={project}
                  authuser={person}
                  config={config}
                  verify={this.verifyMember}
                  remove={this.removeMember}
                  promote={this.promoteMember}
                  navigate={navigate}/>
                {isactive && is_pi && <AddMember
                    add={this.addMember}
                    >
                    <label>Add a Project Member</label>
                </AddMember>}
                <ProjectTags project={project}/>
                {isactive && <ProjectResources project={project} navigate={navigate} isAdmin={isAdmin} />}
              </Styles>
            </div>
        );
    }
}

export default UpdateProjectContainer;
